/**
 * Business functions are used for reaching the endpoints for business.
 * @module Business
 * @since 0.0.6
 */
import GlobalFunctions from '../global'

module.exports = {
	/**
	 * Call to unoapp API that retrieves details about a specific business.
	 * @function
	 * @param {integer} businessId - The id of the business to fetch details for.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.6
	 */
	getBusinessDetails (businessId) {
		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/business/' + businessId,
				data: {},
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	},
	/**
	 * Call to unoapp API that returns an array of businesses for the specified page and search criteria.
	 * @function
	 * @param {integer} pageNumber - The current page that we are retrieving results for.
	 * @param {integer} recordsPerPage - The number of records to return per page.
	 * @param {object} searchCriteria - Object with all criteria to be searched by.
	 * @param {object} sortCriteria - The field and order to be sorted by.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.7
	 */
	getBusinesses (pageNumber, recordsPerPage, searchCriteria, sortCriteria) {
		let httpParams = {page_number: pageNumber, records_per_page: recordsPerPage}
		if (sortCriteria) {
			for (let sortKey in sortCriteria) {
				httpParams[sortKey] = sortCriteria[sortKey]
			}
		}

		if (searchCriteria) {
			for (let searchKey in searchCriteria) {
				httpParams[searchKey] = searchCriteria[searchKey]
			}
		}
		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'POST',
				dataType: 'json',
				url: '/business/search',
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	},
	/**
	 * Call to unoapp API that creates a new business.
	 * @function
	 * @param {object} business - The business to be created.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.7
	 */
	createBusiness (business) {
		let httpParams = {
			business_name: business.business_name,
			apps: business.apps
		}

		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/business',
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	},
	/**
	 * Call to unoapp API that updates an existing business.
	 * @function
	 * @param {integer} businessId - The business id to be updated
	 * @param {object} business - The business details to be updated.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.9
	 */
	updateBusiness (businessId, business) {
		let httpParams = {}

		for (let key in business) {
			httpParams[key] = business[key]
		}

		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'PATCH',
				dataType: 'json',
				url: '/business/' + businessId,
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	},
	/**
	 * Call to unoapp API that adds a business to the blacklist.
	 * @function
	 * @param {integer} businessId - The business id to be blacklisted.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.8
	 */
	addToBlacklist (businessId) {
		let httpParams = {
			business_id: businessId
		}

		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'PUT',
				dataType: 'json',
				url: '/blacklist',
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	},
	/**
	 * Call to unoapp API that removes a business from the blacklist.
	 * @function
	 * @param {integer} businessId - The business id to be removed from the blacklist.
	 * @returns {object} A promise that will return either a success object or an error object.
	 * @version 0.0.8
	 */
	removeFromBlacklist (businessId) {
		let httpParams = {
			business_id: businessId
		}

		return new Promise((resolve, reject) => {
			GlobalFunctions.$ajax({
				method: 'DELETE',
				dataType: 'json',
				url: '/blacklist',
				data: httpParams,
				success (response) {
					resolve(response)
				},
				error (e) {
					let _this = this
					let _wrapper = GlobalFunctions.refreshWrapper((e, status) => {
						if (status === 'error') {
							reject(e)
						} else {
							GlobalFunctions.$ajax(_this)
						}
					})
					_wrapper(e)
				}
			})
		})
	}
}



// WEBPACK FOOTER //
// ./src/controllers/Business.js